import merge from 'webpack-merge'
import baseConfig from './config.base'

const config = {
  hosts: {
    resource: 'http://localhost:3000/',
    request: 'https://air.51s.co/api/'
  },
  apis: {
    session: 'open/backget'
  }
}

export default merge(baseConfig, config)



// WEBPACK FOOTER //
// ./src/config/config.dev.js